import { Component, ChangeDetectionStrategy, Input, signal, WritableSignal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Route, RouterLink } from '@angular/router';
import { RxFor } from '@rx-angular/template/for';
import { RxIf } from '@rx-angular/template/if'
import { ButtonComponent } from '../button/button.component';
import { RxState } from '@rx-angular/state';
import { map, Observable, tap } from 'rxjs';
import { submenuState } from './submenu-state.animation';
import { rxEffects } from '@rx-angular/state/effects';

type RouteWithSubmenu = Route & {
  submenu$?: WritableSignal<boolean> | undefined;
};

interface MenuState {
  routes: Route[],
  routeChanged: void
}

@Component({
  selector: 'lib-menu',
  standalone: true,
  imports: [CommonModule, RxFor, RxIf, RouterLink, ButtonComponent],
  templateUrl: './menu.component.html',
  styleUrl: './menu.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [submenuState]
})
export class MenuComponent {

  // RxState has .hold rxState not
  private state = new RxState<MenuState>();

  private submenuStates = new Map<string, WritableSignal<boolean>>();
  
  readonly routes$: Observable<RouteWithSubmenu[]> = this.state.select('routes').pipe(
    map((routes) => routes.map((route) => {
      
      if (route.children && route.path) {
        this.submenuStates.set(route.path, signal(false));
      }

      return {
        ...route,
        submenu$: route.children && route.path ? this.submenuStates.get(route.path) : undefined
      };

    }))
  );

  @Input()
  set routes(routes$: Observable<Route[]>) {
    this.state.connect('routes', routes$);
  }

  @Input()
  set routeChanged(routeChanged$: Observable<void>) {
    this.state.hold(routeChanged$, () => {
    console.log('MenuComponent routeChanged');
    this.submenuStates.forEach(signal => signal.set(false));
  });
  }

  readonly effects: ReturnType<typeof rxEffects> = rxEffects();

  constructor() {
    
    /* CLOSE ALL SUB MENUS ON ROUTE CHANGE */
    this.effects.register(
      this.state.select('routeChanged'),
      () => this.submenuStates.forEach(signal => signal.set(false))
    );

  }



}
